'use client';

import type { FC } from 'react';
import { Skeleton } from '../ui/Skeleton';

interface RainHistorySkeletonProps {
  rounds?: number;
  winnersPerRound?: number;
}

export const RainHistorySkeleton: FC<RainHistorySkeletonProps> = ({ rounds = 3, winnersPerRound = 3 }) => (
  <div className="flex flex-col gap-3 p-4">
    {Array.from({ length: rounds }).map((_, roundIndex) => (
      <div key={roundIndex} className="overflow-hidden rounded-2xl bg-fill-tertiary">
        <div className="flex items-center gap-3 px-3.5 py-3">
          <Skeleton className="size-10 shrink-0 rounded-lg" />
          <div className="min-w-0 flex-1 leading-tight">

            <Skeleton className="h-6 w-[40%]" />
            <Skeleton className="mt-0.5 h-4 w-[60%]" />
          </div>
        </div>

        {Array.from({ length: winnersPerRound }).map((__, winnerIndex) => (
          <div key={winnerIndex} className="flex w-full items-center gap-3 border-t border-white/5 px-3.5 py-3">
            <Skeleton className="size-12 shrink-0 rounded-full" />
            <div className="min-w-0 flex-1 leading-tight">

              <Skeleton className="h-5 w-[45%]" />
              <Skeleton className="mt-0.5 h-5 w-[70%]" />
              <Skeleton className="mt-0.5 h-[18px] w-[30%]" />
            </div>
            <Skeleton className="size-16 shrink-0 rounded-xl" />
          </div>
        ))}
      </div>
    ))}
  </div>
);
